(function(){
    'use strict';

    angular
        .module('elogbooks.user.patrols')
        .controller('GenericPatrolPointsInfoController', GenericPatrolPointsInfoController);

    GenericPatrolPointsInfoController.$inject = ['$state', '$stateParams', '$filter', 'patrolPointResponse'];

    function GenericPatrolPointsInfoController ($state, $stateParams, $filter, patrolPointResponse) {
        var vm = this;

        vm.patrolPoint = patrolPointResponse;
    }
})();
